module.exports = __webpack_public_path__ + "static/media/jenkins.b76294e7.svg";